<template>
  <label
    :class="[
      'checkbox-label',
      {
        'checkbox-label_active': value,
        'checkbox-label_active-secondary': value && color === 'secondary',
        'checkbox-label_active-muted': value && color === 'muted',
        'checkbox-label_active-muted': disabled,
      },
    ]"
    :for="id"
  >
    <input
      class="checkbox-input"
      :id="id"
      :checked="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.checked)"
      type="checkbox"
    />
    {{ labelText }}
  </label>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      require: true,
    },
    value: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default:false
    },
    labelText: {
      type: [String, Number],
      require: false,
    },
    color: {
      type: String,
      require: false,
    },
  },
};
</script>

<style scoped>
.checkbox-label {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000;
  margin-bottom: 0;
  cursor: pointer;
}

.checkbox-input {
  position: absolute;
  z-index: -100;
  pointer-events: none;
  visibility: hidden;
}

.checkbox-label::before {
  display: block;
  margin-right: 10px;
  content: "";
  min-width: 16px;
  height: 16px;
  background-image: url("../../files/assets/icon/checkbox-icon.svg");
}

.checkbox-label_active::before {
  background-image: url("../../files/assets/icon/checkbox-icon_active.svg");
}
.checkbox-label_active-secondary::before {
  background-image: url("../../files/assets/icon/checkbox-icon_active-secondary.svg");
}
.checkbox-label_active-muted::before {
  background-image: url("../../files/assets/icon/checkbox-icon_active-muted.svg");
}
</style>
